import classNames from 'classnames';
import type { IntlKey } from 'locales';
import { FC } from 'react';
import { useIntl } from 'react-intl';

interface ButtonProps {
  className: string;
  labelKey: IntlKey;
  onClick?: () => void;
  e2e: string;
  disabled: boolean;
}

export const QuoteButton: FC<ButtonProps> = ({ className, labelKey, onClick, disabled, e2e }) => {
  const { formatMessage } = useIntl();
  return (
    <button
      type="button"
      className={classNames('btn btn-xl btn-primary', className)}
      disabled={disabled || onClick === undefined}
      onClick={onClick}
      data-e2e={e2e}
    >
      {formatMessage({ id: labelKey })}
    </button>
  );
};
